import React from 'react';
import styled from 'styled-components';

const EyeIconComponent = ({showPassword, setShowPassword}) => {
  return (
    <EyeIcon onClick={setShowPassword}>
      <EyeBall>
        <EyeColor />
        {(showPassword && <Strike />) || null}
      </EyeBall>
    </EyeIcon>
  );
};

export default EyeIconComponent;

const EyeIcon = styled.div(
  props => `
    width: 15px;
    height: 15px;
    border: solid 1px ${props.theme.colors.grey.lightba};
    border-radius: 75% 15%;
    position: relative;
    transform: rotate(45deg);
    background: ${props.theme.colors.grey.lightba};
    margin: auto;
    margin-right: ${props.theme.spacing.large.l15};
    cursor: pointer;
    z-index: 1;
  `
);

const Strike = styled.div(
  props => `
    width: 1.4px;
    height: 21px;
    position: relative;
    transform: rotate(100deg);
    background: ${props.theme.colors.grey.base1};
    margin: auto;
    cursor: pointer;
    z-index: 1;
    bottom: 6px;
  `
);

const EyeBall = styled.div(
  props => `
    content: '';
    display: block;
    position: absolute;
    width: 11px;
    height: 11px;
    border: solid 1px ${props.theme.colors.grey.lightba}
    border-radius: 50%;
    background: ${props.theme.colors.white.base};
    left: 1px;
    top: 1px;
  `
);

const EyeColor = styled.div(
  props => `
    content: '';
    display: block;
    position: absolute;
    width: 5px;
    height: 5px;
    border: solid 1px ${props.theme.colors.grey.lightba}
    border-radius: 50%;
    background: ${props.theme.colors.grey.lightba};
    left: 2px;
    top: 2px;
  `
);